const family = 'Schibsted Grotesk, sans-serif';
const weight = {
  extraBold: 900,
  bold: 700,
  semiBold: 600,
  medium: 500,
  semiLight: 400,
  light: 300,
};

export const font = {
  family,
  weight,
};
